import { gql } from 'graphql-request'

export const UNLINK_NAIIN_PROVIDER = gql`
  mutation UnlinkNaiinProvider {
    unlinkNaiinProvider {
      message
    }
  }
`
